import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../Slice/auth/authSlice';
import personalFormReducer from '../components/Identify/slice/personalFormSlice';
import legalFormReducer from '../components/Identify/slice/legalFormSlice';
import applicationReducer from '../components/Application/slice/ApplicationSlice';
import unifiedFormReducer from '../Slice/unifiedFormSlice';
import identityChangeReducer from '../Slice/identityChangeSlice';
import agentReducer from '../Slice/reseller/agent/agentSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    personalForm: personalFormReducer,
    legalForm: legalFormReducer,
    application: applicationReducer,
    unifiedForm: unifiedFormReducer,
    identityChange: identityChangeReducer,
    agent: agentReducer,
  },

  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
